import { render } from "./TvmFeedBack.vue?vue&type=template&id=2ef1e864&scoped=true"
import script from "./TvmFeedBack.vue?vue&type=script&lang=js"
export * from "./TvmFeedBack.vue?vue&type=script&lang=js"

import "./TvmFeedBack.vue?vue&type=style&index=0&id=2ef1e864&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef1e864"],['__file',"src/Components/ChatWidget/TvmFeedBack/TvmFeedBack.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ef1e864"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ef1e864', __exports__)) {
    api.reload('2ef1e864', __exports__)
  }
  
  module.hot.accept("./TvmFeedBack.vue?vue&type=template&id=2ef1e864&scoped=true", () => {
    api.rerender('2ef1e864', render)
  })

}


export default __exports__